import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-card-widget',
  templateUrl: './card-widget.component.html',
  styleUrls: ['./card-widget.component.scss']
})
export class CardWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
